module.exports = __webpack_public_path__ + "img/11.6b26f98a.svg";